export default __webpack_public_path__ + "static/media/Abel-Regular.3843f456.ttf";